import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxButton } from 'components/RevxButton';
import {
  JobItem,
  JobUIStatusEnum,
  JobWorkflowStatusEnum,
} from 'domains/workspaceDomain';
import jobService from 'services/jobService';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useState } from 'react';
import { JobStatusFilterSeparateTabEnum } from 'domains/workspaceDomain';
import { useGetJobCountHandler } from 'hooks/useJobStatusCollection';
import useJobCardInfo from '../../hooks/useJobCardInfo';

type Props = {
  data: JobItem;
  filter?: JobUIStatusEnum | JobWorkflowStatusEnum;
};

// const { INVOICING } = JobUIStatusEnum;
const { STANDARD_JOBS, ARCHIVED_INVOICES } = JobStatusFilterSeparateTabEnum;

const CardActionArchiveBtn = ({ data }: Props) => {
  const [loading, setLoading] = useState(false);
  const { workspace } = useAppDispatch();
  const { invoicingTabsKey, reloadGroupJobList } = useAppSelector(
    (state) => state.workspace
  );
  const { hasProxy, hasCustomer, onlyOneParticipant } = useJobCardInfo(data);

  const { archived, id, workflowStatus } = data;
  const { batchJobArchive, batchJobRollbackArchive } = jobService;
  const refreshJobCount = useGetJobCountHandler();
  const isNormalJob =
    invoicingTabsKey === STANDARD_JOBS ||
    invoicingTabsKey === ARCHIVED_INVOICES;
  const archiveHandler = async () => {
    setLoading(true);
    await (archived ? batchJobRollbackArchive : batchJobArchive)(id.toString());
    isNormalJob
      ? await workspace.reloadJobList()
      : await reloadGroupJobList?.();
    await refreshJobCount();
    setLoading(false);
  };
  if (workflowStatus !== JobWorkflowStatusEnum.COMPLETED || !isNormalJob) {
    return null;
  }
  if (onlyOneParticipant && (hasProxy || hasCustomer)) {
    return null;
  }
  return (
    <>
      <RevxFlexLayout justify="justify-center">
        <RevxButton
          loading={loading}
          brandGreen={true}
          onClick={archiveHandler}
        >
          {archived ? 'Move to Open' : 'Move to Archive'}
        </RevxButton>
      </RevxFlexLayout>
    </>
  );
};

export default CardActionArchiveBtn;
